import type { SupabaseClient } from '@supabase/supabase-js';

export async function getConnectedPlatforms(
  supabase: SupabaseClient,
  userId: string,
): Promise<string[]> {
  const { data, error } = await supabase
    .from('user_connections')
    .select('platform')
    .eq('user_id', userId)
    .eq('is_active', true);
  if (error || !data) return [];
  return Array.from(new Set(data.map((r) => r.platform))).sort();
}
